import axios from "axios";
import params from "../configs/params";

const bReviewsApi = axios.create({
  baseURL: params.reviewsUrl,
  withCredentials: true,
});

bReviewsApi.defaults.headers.common["Content-Type"] = "application/json";
bReviewsApi.defaults.headers.common["ngrok-skip-browser-warning"] = "true";

// Add a request interceptor for adding the Authorization header
bReviewsApi.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for handling 401 errors
bReviewsApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle 401 errors (e.g., redirect to login)
      console.error("Unauthorized access - redirecting to login");
    }
    return Promise.reject(error);
  }
);

export default bReviewsApi;
